export const STATUS = {
  pago: { dot: "bg-green-500", text: "text-green-400", bg: "bg-green-500/10", border: "border-green-500/30", label: "Pago" },
  parcial: { dot: "bg-yellow-500", text: "text-yellow-400", bg: "bg-yellow-500/10", border: "border-yellow-500/30", label: "Parcial" },
  atrasado: { dot: "bg-red-500", text: "text-red-400", bg: "bg-red-500/10", border: "border-red-500/30", label: "Atrasado" },
  pendente: { dot: "bg-slate-500", text: "text-slate-400", bg: "bg-white/5", border: "border-border", label: "Pendente" },
};

export const PERIODICIDADE = { semanal: "Semanal", quinzenal: "Quinzenal", mensal: "Mensal" };
export const FORMAS = { dinheiro: "Dinheiro", pix: "Pix", cartao: "Cartão", transferencia: "Transferência", outro: "Outro", quitacao: "Quitação" };
